export const QUERY_KEYS = {
  NOTE_LIST_GET: "NOTE_LIST_GET",
  NOTE_GET: "NOTE_GET",
};
